import React, { useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import About from './pages/About';
import Blog from './pages/Blog';
import Home from './pages/Home';
import Login from './pages/Login';
import AndroidTests from './pages/AndroidTests';
import SQLTrainer from './pages/SQLTrainer';
import NoPage from './pages/NoPage';
import AuthWrapper from './components/AuthWrapper';
import { initSettings } from './actions/SettingsActions';
import { CommonContext } from './contexts/CommonContext';

function Pages({ initSettings }) {
  const themeContext = useContext(CommonContext);

  useEffect(() => {
    const settings = JSON.parse(localStorage.getItem('settings'));
    if (settings) {
      initSettings(settings);
      themeContext.changeTheme(settings.theme);
    }
  }, [initSettings, themeContext]);

  useEffect(() => {
    if (themeContext.theme === 'dark') {
      document.body.classList.remove('light');
    } else {
      document.body.classList.add('light');
    }
  }, [themeContext.theme]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        {/* The games list now lives on the homepage; keep old links working. */}
        <Route path="/games" element={<Navigate to="/" replace />} />
        <Route path="/blog" element={<Blog />}>
          <Route path=":publishDate" element={<Blog />} />
        </Route>
        {/*
          Sign-in for apps outside this router -- Bottom Trumps sends its host here with
          ?next=<relative path> and Login validates it before redirecting. AuthWrapper shows
          LoginScreen until there is a session, so Login only ever renders once there is one.
        */}
        <Route path="/login" element={
          <AuthWrapper>
            <Login />
          </AuthWrapper>
        } />
        <Route path="/android-tests" element={
          <AuthWrapper>
            <AndroidTests />
          </AuthWrapper>
        } />
        <Route path="/sql-trainer" element={
          <AuthWrapper>
            <SQLTrainer />
          </AuthWrapper>
        } />
        <Route path="*" element={<NoPage />} />
      </Routes>
    </BrowserRouter>
  );
}

const mapStateToProps = (state) => ({
  settings: state.settings,
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({ initSettings }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(Pages);